<div class="container-fluid">
    <app-pagetitle title="Patients-List" [breadcrumbItems]="breadCrumbItems"></app-pagetitle>
</div>

<div class="row">
    <div class="col-12">
        <div class="card">
            <div class="row" style="margin: 3%;">
                <form [formGroup]="Perform" (ngSubmit)="searchdata()">
                    <div class="row">
                        <div class="col-md-4 col-sm-4">
                            <div class="form-group mb-4">
                                <label for="name">From Date <span style="color:red">*</span></label>
                                <input type="date" formControlName="pdate" class="form-control"
                                    placeholder="Enter Date" />
                            </div>
                        </div>
                        <div class="col-md-4 col-sm-4">
                            <div class="form-group mb-4">
                                <label for="name">To Date <span style="color:red">*</span></label>
                                <input type="date" formControlName="tdate" class="form-control"
                                    placeholder="Enter Date" />
                            </div>
                        </div>
                        <div class="col-md-4 col-sm-4">
                            <label for="name"></label>
                            <button style="background-color: #44b6ae; border-color: #44b6ae; margin-top: 28px;"
                                type="submit" class="btn btn-primary">
                                Search
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>


<div class="row">
    <div class="col-12">
        <div class="card">
            <div class="card-body">
                <button type="button" class="btn btn-success" (click)="gotoprescriptionlist()">
                    <i class=" ri-menu-2-fill align-middle me-2"></i> Add-Appointment
                </button>
                <div class="row mb-md-2">
                    <div class="col-sm-12 col-md-8">
                        <div class="dataTables_length" id="tickets-table_length">
                            <br>
                            <label class="d-inline-flex align-items-center">Show
                                <select name="tickets-table_length" aria-controls="tickets-table" name="pageSize"
                                    [(ngModel)]="service.pageSize"
                                    class="custom-select custom-select-sm form-control form-control-sm mx-2">
                                    <option [ngValue]="10">10</option>
                                    <option [ngValue]="25">25</option>
                                    <option [ngValue]="50">50</option>
                                    <option [ngValue]="100">100</option>
                                </select> entries
                            </label>
                        </div>
                    </div>

                    <div class="col-sm-12 col-md-2" style="text-align: left">
                        <div class="form-group mb-0" style="text-align: right;">
                            <button class="btn btn-secondary me-1" (click)="downloadExcel()">Excel</button>
                            <button class="btn btn-secondary" (click)="downloadPdf()"> PDF</button>
                        </div>
                    </div>

                    <div class="col-sm-12 col-md-2">
                        <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                            <label class="d-inline-flex align-items-center">Search:
                                <input type="text" name="searchTerm" class="form-control form-control-sm ms-2"
                                    aria-controls="tickets-table" [(ngModel)]="service.searchTerm">
                            </label>
                        </div>
                    </div>

                </div>
            </div>
            <!-- Table -->
            <div class="table-responsive">
                <table id="basic-datatable"
                    class="table table-bordered dt-responsive nowrap datatables no-footer dtr-inline table-striped">
                    <thead class="table-dark">
                        <tr>
                            <th>S.no</th>
                            <th sortable="appointment_date" (sort)="onSort($event)">Appointment-Date</th>
                            
                            <th sortable="patient_id" (sort)="onSort($event)">UHID</th>
                            <th sortable="name" (sort)="onSort($event)">Name</th>
                            <th sortable="age" (sort)="onSort($event)">Age</th>
                            <th sortable="number" (sort)="onSort($event)">Number</th>
                            <th style="min-width: 110px !important;" sortable="dob" (sort)="onSort($event)">Date of
                                Birth</th>
                            <th sortable="gender" (sort)="onSort($event)">Gender</th>
                            <th sortable="amount" (sort)="onSort($event)">Amount</th>
                            <th sortable="expiry_date" (sort)="onSort($event)">Expiry Date</th>
                            <th sortable="problem" (sort)="onSort($event)">Problem </th>
                            <th sortable="department_name" (sort)="onSort($event)">Department</th>
                            <th sortable="doctor_name" (sort)="onSort($event)">Doctor</th>
                            <th sortable="pymnt_type" (sort)="onSort($event)">Payment Type </th>
                            <th sortable="pymnt_details" (sort)="onSort($event)">Payment Details </th>
                            <th sortable="infosource" (sort)="onSort($event)">Information Source </th>
                            <th sortable="discount" (sort)="onSort($event)">Discount % </th>
                            <th sortable="discount_amount" (sort)="onSort($event)">Discount Amount </th>
                            <th sortable="total_amount" (sort)="onSort($event)">Total Amount </th>
                            <!-- <th>Action </th> -->
                            <th>Action </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let table of tables$ | async;let i=index">
                            <td>
                                {{i+1}}
                            </td>
                            <td>
                                {{table.appointment_date | date:'dd-MM-yyyy'}}
                                &nbsp;&nbsp;/&nbsp;&nbsp;{{table.time_slot}}
                            </td>
                            <td>
                                <ngb-highlight [result]="table.patient_id"
                                    [term]="service.searchTerm"></ngb-highlight>
                            </td>
                            <td>
                                {{table.salutation}} {{table.name}} {{table.last_name}}
                            </td>
                            <td>
                                <ngb-highlight [result]="table.age" [term]="service.searchTerm"></ngb-highlight>
                            </td>
                            <td>
                                <ngb-highlight [result]="table.number" [term]="service.searchTerm"></ngb-highlight>
                            </td>
                            <td>
                                {{table.dob | date:'dd-MM-yyyy'}}
                            </td>
                            <td>
                                <ngb-highlight [result]="table.gender" [term]="service.searchTerm"></ngb-highlight>
                            </td>
                            
                            <td>
                                <ngb-highlight [result]="table.amount" [term]="service.searchTerm"></ngb-highlight>
                            </td>
                            <td style="min-width: 110px !important;">{{table.expiry_date}}</td>
                            <td>
                                <ngb-highlight [result]="table.problem" [term]="service.searchTerm"></ngb-highlight>
                            </td>
                            <td>
                                <ngb-highlight [result]="table.department_name"
                                    [term]="service.searchTerm"></ngb-highlight>
                            </td>
                            <td>
                                <ngb-highlight [result]="table.doctor_name" [term]="service.searchTerm"></ngb-highlight>
                            </td>
                            <td>
                                <ngb-highlight [result]="table.pymnt_type" [term]="service.searchTerm"></ngb-highlight>
                            </td>
                            <td>
                                <span *ngIf="table.pymnt_type == 'upi'"> Transaction ID: {{table.upiId}}</span>
                                <!-- <span *ngIf="table.pymnt_type == 'netBanking'">Transaction ID {{table.netBanking}}</span>
                               <span *ngIf="table.pymnt_type == 'card'">Card Number:{{table.cardNumber}} Expiry Date: {{table.expiryDate}} CVV: {{table.cvv}}</span> -->
                                <span *ngIf="table.pymnt_type == 'cash' || table.pymnt_type == 'other'"> - </span>
                            </td>
                            <td>
                                <ngb-highlight
                                    [result]="(table.infosource === undefined || table.infosource === null || table.infosource === 'undefined') ? '-' : table.infosource"
                                    [term]="service.searchTerm"></ngb-highlight>
                            </td>
                            <td>
                                <ngb-highlight [result]="table.discount" [term]="service.searchTerm"></ngb-highlight>
                            </td>
                            <td>
                                {{ (table.discount / 100) * table.amount | number: '1.2-2' }}
                            </td>
                            <td>{{ table.amount - (table.discount / 100) * table.amount | number: '1.2-2' }}</td>

                            <!-- <td>
                                <i style="font-size: 20px;border-radius:5px;background-color: rgb(83, 12, 12);color: white;padding: 4%;"
                                    class="ri-user-shared-2-fill" title="Edit"
                                    (click)="centerModal(centerDataModal,table)"></i>&nbsp;&nbsp;
                            </td> -->
                            <td>
                                <div style="display: flex;">
                                    <!-- (click)="centerModal(centerDataModal,table)" -->
                                    <i style="font-size: 20px;border-radius:5px;background-color: rgb(31, 115, 31);color: white;padding: 2%;"
                                        class="ri-edit-fill" title="Edit"
                                        (click)="centerModals(centerDataModals,table)"></i>&nbsp;&nbsp;
                                    <!-- <i style="font-size: 20px;border-radius:5px;background-color: rgb(83, 12, 12);color: white;padding: 2%;"
                                        class="ri-delete-bin-2-line" title="Delete" (click)="Delete(i)"></i> -->
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <!-- End table -->
            <div class="row justify-content-md-between align-items-md-center mt-2">
                <div class="col-sm-12 col-md-5">
                    <div class="dataTables_info mb-2" id="tickets-table_info" role="status" aria-live="polite">
                        Showing {{service.startIndex}} to {{service.endIndex}} of
                        {{service.totalRecords}}
                        entries
                    </div>
                </div>
                <!-- Pagination -->
                <div class="col-sm-12 col-md-5">
                    <div class="text-md-end float-md-end s pagination-rounded">
                        <ngb-pagination [collectionSize]="total$ | async" [(page)]="service.page"
                            [pageSize]="service.pageSize">
                        </ngb-pagination>
                    </div>
                </div>
                <!-- End Pagination -->
            </div>
        </div>
    </div>
</div>
<ng-template #centerDataModal let-modal>
    <div class="modal-header">
        <h5 class="modal-title mt-0">Add Patient </h5>
        <button type="button" class="btn-close" (click)="modal.dismiss('Cross click')" aria-hidden="true"></button>
    </div>
    <div class="modal-body">
        <form (ngSubmit)="typeSubmit()" [formGroup]="typeValidationForm">
            <br>
            <div class="row">
                <div class="col-lg-4">
                    <div class="form-group">
                        <label>Name : </label> <b style="font-weight: bolder;font-size: 17px;"> {{patient_details.name}}
                        </b>
                    </div>
                </div>
                <div class="col-lg-4">
                    <div class="form-group">
                        <label>Age : </label><b style="font-weight: bolder;font-size: 17px;"> {{patient_details.age}}
                        </b>
                    </div>
                </div>
                <div class="col-lg-4">
                    <div class="form-group">
                        <label>Number : </label><b style="font-weight: bolder;font-size: 17px;">
                            {{patient_details.number}} </b>
                    </div>
                </div>
            </div>
            <hr>
            <div class="row">
                <div class="col-lg-4">
                    <div class="form-group">
                        <label>Guardian (optional)</label>
                        <input type="text" class="form-control" formControlName="guardian"
                            [ngClass]="{'is-invalid': typesubmit && type.guardian.errors}"
                            placeholder="Type something" />
                        <div *ngIf="typesubmit && type.guardian.errors" class="invalid-feedback">
                            <span *ngIf="type.guardian.errors.required">This value is required.</span>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4">
                    <div class="form-group">
                        <label>Aadhar (optional)</label>
                        <input type="text " class="form-control" formControlName="aadhar" minlength="12" maxlength="12"
                            [ngClass]="{'is-invalid': typesubmit && type.aadhar.errors}" placeholder="Type something" />
                        <div *ngIf="typesubmit && type.aadhar.errors" class="invalid-feedback">
                            <span *ngIf="type.aadhar.errors.required">This value is required.</span>
                        </div>
                    </div>
                </div>

                <div class="col-lg-4">
                    <div class="form-group">
                        <label>Consultant Fee <span style="color:red">&nbsp;&nbsp;*</span></label>
                        <input type="text" class="form-control" formControlName="consultant_fee"
                            [ngClass]="{'is-invalid': typesubmit && type.consultant_fee.errors}"
                            placeholder="Type something" (keypress)="numericOnly($event)" />
                        <div *ngIf="typesubmit && type.consultant_fee.errors" class="invalid-feedback">
                            <span *ngIf="type.consultant_fee.errors.required">This value is required.</span>
                        </div>
                    </div>
                </div>

                <div class="col-lg-4">
                    <div class="form-group">
                        <label>No.of days to Expiry<span style="color:red">&nbsp;&nbsp;*</span></label>
                        <input type="number" class="form-control" formControlName="days_to_expiry"
                            [ngClass]="{'is-invalid': typesubmit && type.days_to_expiry.errors}"
                            placeholder="Type something" />
                        <div *ngIf="typesubmit && type.days_to_expiry.errors" class="invalid-feedback">
                            <span *ngIf="type.days_to_expiry.errors.required">This value is required.</span>
                        </div>
                    </div>
                </div>

                <div class="col-lg-4">
                    <div class="form-group">
                        <label>Address (optional)</label>
                        <textarea type="number" class="form-control" formControlName="address"
                            [ngClass]="{'is-invalid': typesubmit && type.address.errors}" placeholder="Type something"
                            rows="3"></textarea>
                        <div *ngIf="typesubmit && type.address.errors" class="invalid-feedback">
                            <span *ngIf="type.address.errors.required">This value is required.</span>
                        </div>
                    </div>
                </div>

                <div class="col-lg-4">
                    <div class="form-group">
                        <label>Blood Pressure (optional)</label>
                        <input type="text" class="form-control" formControlName="blood_pressure"
                            (keypress)="numericOnly($event)"
                            [ngClass]="{'is-invalid': typesubmit && type.blood_pressure.errors}"
                            placeholder="Type something" />
                        <div *ngIf="typesubmit && type.blood_pressure.errors" class="invalid-feedback">
                            <span *ngIf="type.blood_pressure.errors.required">This value is required.</span>
                        </div>
                    </div>
                </div>

                <div class="col-lg-4">
                    <div class="form-group">
                        <label>Sugar (optional)</label>
                        <input type="text" class="form-control" formControlName="sugar"
                            [ngClass]="{'is-invalid': typesubmit && type.sugar.errors}" placeholder="Type something" />
                        <div *ngIf="typesubmit && type.sugar.errors" class="invalid-feedback">
                            <span *ngIf="type.sugar.errors.required">This value is required.</span>
                        </div>
                    </div>
                </div>

                <div class="col-lg-4">
                    <div class="form-group">
                        <label>Weight (optional)</label>
                        <input type="text" class="form-control" formControlName="weight"
                            (keypress)="numericOnly($event)"
                            [ngClass]="{'is-invalid': typesubmit && type.weight.errors}" placeholder="Type something" />
                        <div *ngIf="typesubmit && type.weight.errors" class="invalid-feedback">
                            <span *ngIf="type.weight.errors.required">This value is required.</span>
                        </div>
                    </div>
                </div>

                <div class="col-lg-4">
                    <div class="form-group">
                        <label>Height (optional)</label>
                        <input type="number" class="form-control" formControlName="height"
                            [ngClass]="{'is-invalid': typesubmit && type.height.errors}" placeholder="Type something" />
                        <div *ngIf="typesubmit && type.height.errors" class="invalid-feedback">
                            <span *ngIf="type.height.errors.required">This value is required.</span>
                        </div>
                    </div>
                </div>

                <div class="col-lg-4">
                    <div class="form-group">
                        <label>Others (optional)</label>
                        <input type="text" class="form-control" formControlName="others"
                            [ngClass]="{'is-invalid': typesubmit && type.others.errors}" placeholder="Type something" />
                        <div *ngIf="typesubmit && type.others.errors" class="invalid-feedback">
                            <span *ngIf="type.others.errors.required">This value is required.</span>
                        </div>
                    </div>
                </div>

                <div class="form-group mb-0" style="text-align: right;">
                    <button type="submit" class="btn btn-primary me-1"> Submit </button>
                    <button type="reset" class="btn btn-secondary"> Reset </button>
                </div>
            </div>
        </form>
    </div>
</ng-template>
<ng-template #centerDataModals let-modal>
    <div class="modal-header">
        <h5 class="modal-title mt-0">Edit Appointment details </h5>
        <button type="button" class="btn-close" (click)="modal.dismiss('Cross click')" aria-hidden="true"></button>
    </div>
    <div class="modal-body">
        <form (ngSubmit)="edit()" [formGroup]="typeeditForm">
            <br>
            <div class="row">
                <div class="col-lg-4">
                    <div class="form-group">
                        <label>Name : </label>
                        <input type="text" class="form-control" formControlName="name"
                            [ngClass]="{'is-invalid': typesubmit && type.name.errors}"
                            placeholder="Type something" />
                    </div>
                </div>
                <div class="col-lg-4">
                    <div class="form-group">
                        <label>Surname : </label>
                        <input type="text" class="form-control" formControlName="last_name"
                            [ngClass]="{'is-invalid': typesubmit && type.last_name.errors}"
                            placeholder="Type something" />
                    </div>
                </div>
                <div class="col-lg-4">
                    <div class="form-group">
                        <label>Age : </label>
                        <input type="text" class="form-control" formControlName="age"
                            [ngClass]="{'is-invalid': typesubmit && type.first_name.errors}"
                            placeholder="Type something" />
                    </div>
                </div>
                <div class="col-lg-4">
                    <div class="form-group">
                        <label>Number : </label><input type="text" class="form-control" formControlName="number"
                            [ngClass]="{'is-invalid': typesubmit && type.first_name.errors}"
                            placeholder="Type something" />
                    </div>
                </div>
            </div>
            <hr>
            <div class="row">
                <div class="col-lg-4">
                    <div class="form-group">
                        <label>Date of Birth</label>
                        <input type="date" class="form-control" formControlName="dob"
                            [ngClass]="{'is-invalid': typesubmit && type.guardian.errors}"
                            placeholder="Type something" />
                        <div *ngIf="typesubmit && type.guardian.errors" class="invalid-feedback">
                            <span *ngIf="type.guardian.errors.required">This value is required.</span>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4">
                    <div class="form-group">
                        <label>Gender</label>
                        <select formControlName="gender" class="form-control"
                            [ngClass]="{'is-invalid': typesubmit && type.gender.errors}">
                            <option value="" selected>Select</option>
                            <option value="Male">Male</option>
                            <option value="Female">Female</option>
                            <option value="Other">Other</option>
                        </select>
                        <div *ngIf="typesubmit && type.aadhar.errors" class="invalid-feedback">
                            <span *ngIf="type.aadhar.errors.required">This value is required.</span>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4">
                    <div class="form-group">
                        <label>Amount<span style="color:red">&nbsp;&nbsp;*</span></label>
                        <input type="number" class="form-control" formControlName="amount"
                            [ngClass]="{'is-invalid': typesubmit && type.days_to_expiry.errors}"
                            placeholder="Type something" />
                        <div *ngIf="typesubmit && type.days_to_expiry.errors" class="invalid-feedback">
                            <span *ngIf="type.days_to_expiry.errors.required">This value is required.</span>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4">
                    <div class="form-group">
                        <label>Doctor Name <span style="color:red">&nbsp;&nbsp;*</span></label>
                        <ng-select formControlName="doctor_name" (change)="getdep($event)"
                            [ngClass]="{'is-invalid': typesubmit && type.doctor_name.errors}">
                            <ng-option value="" disabled Selected>Select The Doctor</ng-option>
                            <ng-option *ngFor="let i of doctordata"
                                value="{{i.doctor_name}}">{{i.doctor_name}}</ng-option>
                        </ng-select>
                        <div *ngIf="typesubmit && type.doctor_name.errors" class="invalid-feedback">
                            <span *ngIf="type.doctor_name.errors.required">This value is required.</span>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4">
                    <div class="form-group">
                        <label>Department Name <span style="color:red">&nbsp;&nbsp;*</span></label>
                        <input type="text" class="form-control" formControlName="department_name"
                            [ngClass]="{'is-invalid': typesubmit && type.department_name.errors}"
                            placeholder="Type something" />
                        <div *ngIf="typesubmit && type.department_name.errors" class="invalid-feedback">
                            <span *ngIf="type.department_name.errors.required">This value is required.</span>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4">
                    <div class="form-group">
                        <label>Problem<span style="color:red">&nbsp;&nbsp;*</span></label>
                        <input type="text" class="form-control" formControlName="problem"
                            [ngClass]="{'is-invalid': typesubmit && type.days_to_expiry.errors}"
                            placeholder="Type something" />
                        <div *ngIf="typesubmit && type.days_to_expiry.errors" class="invalid-feedback">
                            <span *ngIf="type.days_to_expiry.errors.required">This value is required.</span>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4">
                    <div class="form-group">
                        <label>Payment type <span style="color:red">&nbsp;&nbsp;*</span></label>
                        <ng-select id="inputstate" id="default-select" formControlName="pymnt_type"
                            (change)="selectfield($event)" [class.is-invalid]="typesubmit && type.pymnt_type.errors">
                            <ng-option value="" selected>Select Payment Method</ng-option>
                            <ng-option value="cash">Cash</ng-option>
                            <ng-option value="upi">UPI</ng-option>
                            <ng-option value="other">Other</ng-option>
                        </ng-select>
                        <div *ngIf="typesubmit && type.pymnt_type.errors" class="invalid-feedback">
                            <span *ngIf="type.pymnt_type.errors.required">This value is required.</span>
                        </div>
                    </div>
                </div>

                <!-- UPI Field (Hidden initially) -->
                <div class="col-lg-4" *ngIf="upi">
                    <div class="form-group">
                        <label>Enter Transaction ID <span style="color:red">&nbsp;&nbsp;*</span></label>
                        <input type="text" class="form-control" formControlName="upiId"
                            [ngClass]="{'is-invalid': typesubmit && type.amount.errors}"
                            placeholder="Enter Transaction ID" />

                    </div>
                </div>
            </div>
            <br>
            <div class="form-group mb-0" style="text-align: right;">
                <button type="submit" class="btn btn-primary me-1"> Submit </button>
                <button type="reset" class="btn btn-secondary"> Reset </button>
            </div>

        </form>
    </div>
</ng-template>